import { Injectable } from '@angular/core';
import { Resource, ResourceParams, ResourceHandler, ResourceAction, ResourceRequestMethod, IResourceMethodPromise } from '@ngx-resource/core';
export interface IAccount {
  accesstoken: string;
  refreshtoken: string;
  mybusiness: any;
  newAccount: boolean;
  user: {
    email: String,
    phone: String,
    mybUID: String,

    salutation: String,
    companyName: String,
    firstname: String,
    insertion: String,
    lastname: String,

    address: {
      streetandnr: String,
      postalcode: String,
      city: String,
      country: String
    },
  };
}

@ResourceParams({
  pathPrefix: '/api/account'
})
@Injectable()
export class AccountResource extends Resource {

  constructor(handler: ResourceHandler) {
    super(handler);
  }


  @ResourceAction({
    method: ResourceRequestMethod.Post,
    path: ''
  })
  update: IResourceMethodPromise<any, any>;

  @ResourceAction({
    method: ResourceRequestMethod.Get,
    path: '/exists/{!email}'
  })
  checkEmail: IResourceMethodPromise<{ email }, any>;

}
